import {Link} from 'react-router-dom'
import EntityPerformanceChartModal from '../../../../components/EntityPerformanceChartModal/EntityPerformanceChartModal'
import {useContext, useState} from 'react'
import {SalesRepTypeReportContext} from '../../context'
import { MIN_DATE_RANGE } from '../../utils'

const SalesRepTypeReportRow = ({row}: any) => {
  const [showChartModal, setShowChartModal] = useState(false)
  const {
    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useContext(SalesRepTypeReportContext)

  return (
    <>
      <tr>
        <td>{row.salesRepType}</td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=discount&rep_type=${row.salesRepType}`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.orderCount}
          </Link>
        </td>
        <td>{row.discountValue}</td>
        <td>{row.contributedDiscountPercentage}</td>
        <td>
          <div className='d-flex justify-content-end'>
            <span
              onClick={() => setShowChartModal(true)}
              className='w-30px h-30px d-flex justify-content-center align-items-center text-primary cursor-pointer'
            >
              <i className='fas fa-chart-line text-primary'></i>
            </span>
          </div>
        </td>
      </tr>
      {showChartModal && (
        <EntityPerformanceChartModal
          onClose={() => setShowChartModal(false)}
          entityId={row.salesRepType}
          entityName={`Discount Report - ${row.salesRepType}`}
          onEntityPerformanceChartIdChange={onEntityPerformanceChartIdChange}
          onEntityPerformanceChartViewChange={onEntityPerformanceChartViewChange}
          onEntityPerformanceChartDateRangeChange={onEntityPerformanceChartDateRangeChange}
          entityPerformanceChartFilters={entityPerformanceChartFilters}
          isEntityPerformanceChartDataLoading={isEntityPerformanceChartDataLoading}
          entityPerformanceChartData={entityPerformanceChartData}
          startDate={MIN_DATE_RANGE}
        />
      )}
    </>
  )
}

export default SalesRepTypeReportRow
